(function () {
    'use strict';
    // Placeholder module for the templateCache to attach to
    angular.module('components.templates', []);
})();